import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import BuildIcon from '@mui/icons-material/Build';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import RealmDivision from './RealmDivision';
import { map } from 'global/lib/lodash';

export default function PerformRealmBuilder({
    realm = {},
    currentBuilder = '0',
    changeBuilder = () => {},
    ...props
  }) {
  const builder = realm;
  const [active, setActive] = useState(false);

  const toggleActive = () => {
    setActive(!active);
  };

  return (
    <>
      <ListItem button onClick={() => toggleActive()}>
        <ListItemIcon>
          <BuildIcon />
        </ListItemIcon>
        <ListItemText primary={builder.name} />
      </ListItem>
      {active ? (
        <List>
          {map(builder.realms, (item) => {
            return <RealmDivision key={item.id} realm={item} />;
          })}
        </List>
      ) : (
        <></>
      )}
    </>
  );
}

PerformRealmBuilder.propTypes = {
  realm: PropTypes.object,
  currentBuilder: PropTypes.string,
  changeBuilder: PropTypes.func,
};
